/*
 * @Author: your name
 * @Date: 2021-09-23 10:39:56
 * @LastEditTime: 2021-09-24 15:23:57
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\account\api.js
 */
export const api = {
  text: {
    textParsing: "/bms/vehicleReservation/textParsing.json", // 文本解析
    addEnter: "/bms/vehicleReservation/addEnterVehicleReservation.json", // 客服录入
  },
  import: {
    queryCustomerImportDataPage: "/bms/vehicleReservation/queryCustomerImportDataPage.json",// "查询客服核对保存数据列表"
    updateCustomerImportData: "/bms/vehicleReservation/updateCustomerImportData.json", // 更新客服核对保存数据列表
    deleteCustomerImportData: "/bms/vehicleReservation/deleteCustomerImportData.json", // 删除客服核对保存数据列表
    customerImportData: "/bms/vehicleReservation/customerImportData.json", // 客服核对保存数据
    queryAnalyzeData: "/bms/vehicleReservation/queryImportDataPage.json", // 查询解析数据
    uploadTemplateFile: "/bms/vehicleReservation/excelParsing.json", // Excel 解析(上传)
    getTemplateFile:
      "/common/file/downLoadTemplateFile.json?templateFileName=customerImportData.xlsx", //下载 Excel 模板
  },
  ocr: {
    imageParsing: "/bms/vehicleReservation/ocrImagesParsing.json", // ocr图片解析
  }
};
